(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileOffice365EmailsEmailEmailInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "modals", "rolesManager", "$rootScope", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, modals, rolesManager, $rootScope) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/office365_emails_email/email-info').template('email-info'),
            scope: { shared: '=?profileOffice365EmailsEmailEmailInfo' },
            link: function ($scope, element, attrs) {
                var titlePrefix = $scope.shared.titlePrefix ? $scope.shared.titlePrefix + '#' + JSON.stringify({
                    display: 'text',
                    text: ' - ',
                    'class': 'title-saas-dash'
                }) : '';
                $scope.shared.title = $scope.shared.titlePrefix;
                $scope.shared.titleClass = {};
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    return $q.when();
                };
                $scope.recipientsWidget = {
                    logic: {
                        name: 'emailRecipientsListLogic',
                        updateTick: 90000
                    },
                    'class': 'light medium-icons meta-like',
                    wrapper: { type: 'none' },
                    columns: [
                        {
                            id: 'type',
                            text: 'Type',
                            dataStyle: { 'text-transform': 'capitalize' }
                        },
                        {
                            id: 'users',
                            text: false,
                            converter: 'listConverter',
                            converterArgs: {
                                countPrefix: 'Total:',
                                collapseRest: true,
                                expanded: 4,
                                name: 'col-from-to',
                                showAll: true,
                                rowClass: 'meta-info-row',
                                itemConverter: 'inlineUserWithEmail',
                                itemConverterArgs: {
                                    userIdColumn: 'entity_id',
                                    emailColumn: 'mail',
                                    addAllEmailsLink: true
                                },
                                itemConverterScope: 'element',
                                itemConverterTextColumn: 'displayName',
                                'class': 'dropdown-auto-one-line'
                            }
                        }
                    ]
                };
                $scope.infoWidget = {
                    logic: {
                        name: 'emailMetaInfoLogic',
                        beautifyKey: true,
                        advanced: true,
                        subjectTitle: false,
                        updateTick: 30000,
                        entityDataMaster: true,
                        extendEntityInfo: {
                            userAliases: {
                                label: 'User Aliases',
                                ticket_view_default_order: 13,
                                ticket_view_advanced_order: 13
                            },
                            ui_x_originating_ip: {
                                label: 'Sending-client IP',
                                ticket_view_default_order: 15,
                                ticket_view_advanced_order: 15
                            },
                            geo_country: {
                                label: 'Sending-client Country',
                                ticket_view_default_order: 16,
                                ticket_view_advanced_order: 16
                            },
                            geo_region: {
                                label: 'Sending-client Region',
                                ticket_view_default_order: 17,
                                ticket_view_advanced_order: 17
                            },
                            geo_city: {
                                label: 'Sending-client City',
                                ticket_view_default_order: 18,
                                ticket_view_advanced_order: 18
                            }
                        },
                        whitelistEntityInfo: {
                            encryption_status: {
                                name: 'encryption_status',
                                index: false,
                                is_mandatory: false,
                                null: true,
                                value_type: 'TEXT',
                                label: 'Encryption Status',
                                ticket_view_default_order: 19,
                                ticket_view_advanced_order: 19
                            }
                        },
                        converters: {
                            userAliases: {
                                converter: 'limitedArrayConverter',
                                args: {
                                    collapseRest: true,
                                    expanded: 10,
                                    countPostfix: 'aliases'
                                }
                            },
                            recipients: {
                                converter: 'limitedArrayConverter',
                                args: {
                                    collapseRest: true,
                                    expanded: 5,
                                    countPrefix: 'Total:',
                                    name: 'recipients',
                                    showAll: true,
                                    rowClass: 'meta-info-row'
                                }
                            }
                        }
                    },
                    uuid: '265cd681-6b2e-4dcb-98a1-234a2b202773',
                    wrapper: { type: 'none' },
                    pair: { 'class': 'email-meta-data' }
                };
                $scope.restoreRequestWidget = {
                    logic: {
                        name: 'emailRestoreRequestLogic',
                        entityDataSlave: true
                    },
                    'class': 'restore-request-widget',
                    style: { display: 'none' },
                    wrapper: { type: 'none' }
                };
                $scope.actionsWidget = {
                    type: 'actions',
                    logic: {
                        name: 'remediationActionsLogic',
                        updateTick: 30000,
                        entityType: 'office365_emails_email',
                        entityDataSlave: true
                    },
                    'class': 'file-info-actions-widget wide-250-buttons',
                    wrapper: { type: 'none' },
                    actions: rolesManager.isActionAllowed([
                        'admin',
                        'user',
                        'operations'
                    ]) ? [
                        {
                            autoId: 'profile_manual_action_btn_office365_emails_email_quarantine',
                            actionType: 'office365_emails_email_quarantine',
                            disabledEntityAny: {
                                is_quarantined: true,
                                is_deleted_message: true
                            },
                            disabledEntityByApi: {
                                is_quarantinable: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            hiddenEntityAny: {
                                is_quarantined_notification: true,
                                is_quarantined_user_notification: true,
                                is_pre_release_message: true
                            },
                            hiddenEntityAll: [
                                {
                                    is_deleted_message: true,
                                    is_quarantined: false
                                },
                                {
                                    is_sent_from_internal: true,
                                    has_internal_recipient: {
                                        operator: 'not_equal',
                                        value: true
                                    }
                                },
                                {
                                    is_restored_from_quarantine: true,
                                    workflow: {
                                        operator: 'not_partof',
                                        value: 'none, user, admin'
                                    }
                                }
                            ],
                            hiddenEntityByApi: {
                                is_quarantinable: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            }
                        },
                        {
                            autoId: 'profile_manual_action_btn_office365_emails_email_restore',
                            actionType: 'office365_emails_email_restore',
                            additionalAction: 'release_to_all_recipients',
                            hiddenEntityAny: {
                                is_quarantined: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            disabledEntityAny: { is_quarantined_restored: true },
                            disabledEntityByApi: {
                                is_restorable: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            hiddenEntityByApi: {
                                is_restorable: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            feature: 'emailRestore'
                        },
                        {
                            autoId: 'profile_manual_action_btn_office365_emails_restore_decline',
                            actionType: 'office365_emails_restore_decline',
                            hiddenEntityAny: {
                                is_quarantined: {
                                    operator: 'not_equal',
                                    value: true
                                },
                                is_restore_declined: true,
                                restoration_requested: false,
                                is_quarantined_restored: true
                            },
                            feature: 'emailRestore'
                        },
                        {
                            autoId: 'profile_manual_action_btn_office365_emails_email_restore_original',
                            actionType: 'office365_emails_email_restore_original',
                            hiddenEntityAny: {
                                is_attachment_changed: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            disabledEntityAny: { is_attachment_restored: true },
                            feature: 'attachmentRestore'
                        },
                        {
                            autoId: 'profile_manual_action_btn_office365_emails_email_send_original',
                            actionType: 'office365_emails_email_send_original',
                            hiddenEntityAny: {
                                is_deleted_message: {
                                    operator: 'not_equal',
                                    value: false
                                },
                                is_quarantined: {
                                    operator: 'not_equal',
                                    value: false
                                },
                                is_restored_from_quarantine: {
                                    operator: 'not_equal',
                                    value: false
                                }
                            },
                            hiddenSecEntityAny: { clicktime_protection: { result: 'no_links_replaced' } }
                        }
                    ] : []
                };
                $scope.filters = {
                    uuid: '265cd681-6b2e-4dcb-98a1-234a2b202773',
                    filters: [{
                            type: 'flag',
                            text: 'Advanced',
                            value: 'advanced',
                            local: true
                        }]
                };
                var debugAllEmailsWidget = {
                    type: 'multi-widget',
                    logic: {
                        name: 'allUserEmailsLogic',
                        userEntityType: 'office365_emails_user',
                        emailField: 'mail',
                        updateTick: null
                    },
                    options: {
                        pagesAround: 2,
                        pageSize: 20,
                        pagination: { page: 1 },
                        disableTop: true,
                        dropdownHeader: true,
                        defaultOrdering: {
                            columnName: 'ReceivedDateTime',
                            order: 'desc'
                        }
                    },
                    'class': 'light medium-icons',
                    wrapper: {
                        type: 'widget-panel',
                        title: 'All Emails with User',
                        'class': 'avanan white-body overflow-auto'
                    },
                    bodyStyle: { height: 'calc(100vh - 170px)' },
                    columns: [
                        {
                            id: 'entity_id',
                            hidden: true
                        },
                        {
                            id: 'ReceivedDateTime',
                            text: 'Received',
                            format: 'time',
                            sortable: true,
                            'class': 'one-line-date',
                            filter: {
                                type: 'date',
                                name: 'ReceivedDateTime_filter'
                            }
                        },
                        {
                            id: 'from_mail',
                            hidden: true
                        },
                        {
                            id: 'From',
                            hidden: true
                        },
                        {
                            id: 'from_is_external_user',
                            hidden: true
                        },
                        {
                            id: 'from_name',
                            text: 'From',
                            converter: 'userWithEmail',
                            converterArgs: {
                                userIdColumn: 'From',
                                emailColumn: 'from_mail',
                                isExternalColumn_disabled: 'from_is_external_user'
                            },
                            sortable: true,
                            filter: {
                                type: 'text',
                                name: 'from_filter'
                            }
                        },
                        {
                            id: 'recipients',
                            text: 'Recipients',
                            converter: 'listConverter',
                            converterArgs: {
                                countPostfix: 'recipients',
                                collapseRest: true,
                                expanded: 4,
                                itemConverter: 'userWithEmail',
                                itemConverterArgs: {
                                    userIdColumn: 'recipient_id',
                                    emailColumn: 'mail',
                                    isExternalColumn_disabled: 'is_external_user'
                                },
                                itemConverterScope: 'element',
                                itemConverterTextColumn: 'recipient_name'
                            },
                            filter: {
                                type: 'text',
                                name: 'recipients_filter'
                            }
                        },
                        {
                            id: 'Subject',
                            text: 'Subject',
                            sortable: true,
                            href: {
                                type: 'email',
                                params: {
                                    id: 'entity_id',
                                    emptyLinkText: 'Missing subject - click here for the email'
                                }
                            },
                            filter: {
                                type: 'text',
                                name: 'subject_filter'
                            },
                            dropdownPosition: 'left'
                        }
                    ]
                };
                $scope.$on('show-all-user-emails', function (event, data) {
                    if (debugAllEmailsWidget.logic.userId !== data.userId) {
                        delete debugAllEmailsWidget.data;
                        debugAllEmailsWidget.logic.userId = data.userId;
                        debugAllEmailsWidget.wrapper.Loading = true;
                    }
                    delete debugAllEmailsWidget.options.pagination.columnsFilters;
                    modals.widget({
                        panel: debugAllEmailsWidget,
                        windowClass: 'size-xl',
                        closeOnNavigate: true
                    });
                });
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
                $scope.$watch('infoWidget.entityData', function () {
                    if (!$scope.infoWidget.entityData || _($scope.infoWidget.entityData).isEmpty()) {
                        return;
                    }
                    if ($scope.infoWidget.entityData.pre_release_id && $scope.infoWidget.entityData.pre_release_id !== 'NULL') {
                        widgetPolling.scope().originalId = $scope.infoWidget.entityData.pre_release_id;
                    }
                    if ($scope.infoWidget.entityData.splittable) {
                        $scope.shared.splittable = true;
                    }
                    $scope.shared.entityInfoLoaded = true;
                    $scope.restoreRequestWidget.entityData = $scope.infoWidget.entityData;
                    $scope.actionsWidget.entityData = $scope.infoWidget.entityData;
                    $scope.actionsWidget.secEntityData = $scope.infoWidget.secEntityData;
                    if ($scope.infoWidget.actionStatus) {
                        $scope.actionsWidget.actionStatus = $scope.infoWidget.actionStatus;
                    }
                    if ($scope.infoWidget.entityData && $scope.infoWidget.entityData.Subject) {
                        $scope.shared.title = titlePrefix + '#' + JSON.stringify({
                            display: 'linked-text',
                            'class': 'profile-title-container',
                            text: '"' + '#' + JSON.stringify({
                                display: 'text',
                                'class': 'email-subject',
                                text: $scope.infoWidget.entityData.Subject
                            }) + '"'
                        });
                        $scope.shared.titleClass['subject-title'] = true;
                    }
                });
                $scope.$on('$locationChangeStart', function () {
                    $rootScope.isOpenedModal = false;
                });
            }
        };
    }]);
}());